import 'react-phone-number-input/style.css';
import { useMutation, useQuery } from '@apollo/client';
import { Field, Form, Formik } from 'formik';
import _ from 'lodash';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Button, Form as FormB } from 'react-bootstrap';
import PhoneInput, { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import { Link, useHistory, useLocation } from 'react-router-dom';
import ym from 'react-yandex-metrika';
import styled from 'styled-components';
import * as yup from 'yup';
import Cookies from 'universal-cookie';

import { GQL_GET_ME, GQL_LOGIN, GQL_SIGNUP } from '../../graphql/queries';
import { Eye } from '../../helpers/authStyle';
import { ACTIVE, MAIN_GRAY } from '../../helpers/colors';
import { LANG_RU } from '../../locales';
import { useTranslation } from '../hooks/useTranslation';
import Icon from '../Icon';
import { yEvent } from '../Tracker';
import ArtField from './ArtField';

const LoginRegister = ({ labelLogin, path }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const alert = useAlert();
  const location = useLocation();
  const cookies = new Cookies();

  const [show, setShow] = useState(false);
  const [isLogin, setLogin] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);
  const [mainPass, setMainPass] = useState(true);
  const [repeatPass, setRepeatPass] = useState(true);
  const [password, setPass] = useState(false);
  const [pass, setLoginPass] = useState(false);
  const [passwordRepeat, setPassRepeat] = useState('');

  const { data: dataMe } = useQuery(GQL_GET_ME, { fetchPolicy: 'cache-only' });

  const [signup] = useMutation(GQL_SIGNUP);

  const [login] = useMutation(GQL_LOGIN);

  const me = _.get(dataMe, 'me', null);

  useEffect(() => {
    ym('hit', '/signup');
  }, []);

  useEffect(() => {
    if (_.get(me, '_id')) {
      const search = queryString.parse(_.get(location, 'search', {}));
      const goto = cookies.get('goto');
      if (goto) {
        cookies.remove('goto');
        history.push(goto);
      } else if (_.get(search, 'returnUrl', false)) {
        const { returnUrl } = search;
        history.push(returnUrl);
      } else {
        history.push('/');
      }
    }
  }, [_.get(me, '_id', false)]);

  const validatePhone = (phone) => (phone
    ? isPossiblePhoneNumber(phone)
    && isValidPhoneNumber(phone)
    : true);

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    const search = queryString.parse(_.get(location, 'search', {}));
    const { returnUrl } = search;
    try {
      const response = await signup({ variables: values });

      sessionStorage.setItem('viewStartWindow', true);
      cookies.set('goto', path);
      const error = _.get(response, 'errors.0', false);
      if (error) {
        if (_.get(error, 'extensions.code') === '401') {
          return false;
        }
        alert.show(error.message, { type: 'danger' });
        setSubmitting(false);
        setErrors({
          email: error.message,
        });
      } else {
        alert.show(t('send_instructions', { ns: 'alerts' }), { type: 'info' });
        history.push(returnUrl || '/account');
      }
    } catch (e) {
      alert.show(t('admin_error', { ns: 'alerts' }), { type: 'danger' });
      // eslint-disable-next-line no-console
      console.log(e);
    }
    return true;
  };

  const handleLoginSubmit = async (values, { setSubmitting, setErrors }) => {
    const response = await login({
      variables: values,
      refetchQueries: [
        {
          query: GQL_GET_ME,
        },
      ],
    });
    const error = _.get(response, 'errors.0', {});
    if (!_.isEmpty(error)) {
      if (_.get(error, 'extensions.code') === '401') {
        return false;
      }
      alert.show(error.message, { type: 'danger' });
      setSubmitting(false);
      setErrors({
        username: t('error_username', { ns: 'login' }),
        password: t('error_password', { ns: 'login' }),
      });
    }
    return true;
  };

  const handlePasswordCheck = (e) => {
    const passId = e.target.name === 'password' ? e.target.value.trim() : password;
    const passRepeat = e.target.name === 'passwordRepeat' ? e.target.value.trim() : passwordRepeat;
    setPass(passId);
    setPassRepeat(passRepeat);
  };

  const metrica = (target) => {
    yEvent(target);
  };
  const nameRegex = /^[a-zA-Zа-яА-ЯйЙёЁ0-9 ]+$/;

  const validationLoginSchema = yup.object().shape({
    username: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .nullable(),
    password: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .nullable(),
  });

  const validationSchema = yup.object().shape({
    name: yup.string()
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .matches(nameRegex, t('text_num_space', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .nullable(),
    email: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .max(70, t('maximum_length', { ns: 'validate', count: 70 }))
      .email(t('email_format', { ns: 'validate' })),
    phone: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .max(20, t('maximum_length', { ns: 'validate', count: 20 })),
    password: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .min(8, t('minimum_length', { ns: 'validate', count: 8 }))
      .max(70, t('maximum_length', { ns: 'validate', count: 70 })),
    passwordRepeat: yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .oneOf([yup.ref('password', { ns: 'validate' })], t('passwords_are_not_match', { ns: 'signup' }))
      .min(8, t('minimum_length', { ns: 'validate', count: 8 }))
      .max(70, t('maximum_length', { ns: 'validate', count: 70 })),
  });

  return isLogin ? (
    <Formik
      initialValues={{ username: '', password: '' }}
      validationSchema={validationLoginSchema}
      onSubmit={handleLoginSubmit}
      enableReinitialize
    >
      {({ isSubmitting }) => (
        <Form>
          {labelLogin && labelLogin}
          <Field
            name="username"
            disabled={isSubmitting}
            className="form-control-lg"
            placeholder={t('username_placeholder', { ns: 'login' })}
            component={ArtField}
            column
          />
          <Field
            name="password"
            disabled={isSubmitting}
            className="form-control-lg"
            placeholder={t('password_placeholder', { ns: 'login' })}
            type={!pass ? 'password' : 'text'}
            component={ArtField}
            column
            append={(
              <Eye
                type="button"
                onClick={() => setLoginPass(!pass)}
              >
                <Icon
                  icon="eye"
                  colorFill="#FFF"
                  width={24}
                  height={12}
                  colorStroke={!pass ? MAIN_GRAY : ACTIVE}
                  noHover
                />
              </Eye>
              )}
          />
          <LinkReset
            to="/reset"
          >
            {t('forgot_password', { ns: 'login' })}
          </LinkReset>
          {/* eslint-disable-next-line max-len */}
          <div>
            <Button
              variant="primary"
              onClick={() => metrica('login')}
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? t('await', { ns: 'action' }) : t('login_btn', { ns: 'login' })}
            </Button>
            <Authorization>
              <div>{t('no_account', { ns: 'login' })}</div>
              <Button
                variant="link"
                disabled={isSubmitting}
                className="ms-2"
                onClick={() => setLogin(false)}
              >
                {t('registration', { ns: 'login' })}
              </Button>
            </Authorization>
          </div>
        </Form>
      )}
    </Formik>
  ) : (
    <Formik
      initialValues={{
        name: '',
        username: '',
        password: '',
        phone: '',
        passwordRepeat: '',
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        isSubmitting,
        isValid,
        dirty,
        values,
        setFieldValue,
        errors,
      }) => (
        <Form
          onChange={handlePasswordCheck}
          autoComplete="off"
        >
          <Field
            name="name"
            disabled={isSubmitting}
            className="form-control-lg"
            placeholder={t('complete_username_placeholder', { ns: 'signup' })}
            component={ArtField}
            column
          />
          <Field
            name="email"
            required
            disabled={isSubmitting}
            className="form-control-lg"
            placeholder={t('email_placeholder', { ns: 'signup' })}
            component={ArtField}
            column
            onChange={handlePasswordCheck}
          />
          <PhoneInput
            placeholder={t('phone_placeholder', { ns: 'signup' })}
            // international
            name="phone"
            disabled={isSubmitting}
            required
            autoComplete="off"
            className={(_.get(errors, 'phone') || !validatePhone(values.phone)) ? 'is-invalid' : ''}
            value={values.phone}
            defaultCountry={LANG_RU.toUpperCase()}
            onChange={(val) => setFieldValue('phone', val)}
          />
          {(_.get(errors, 'phone') || !validatePhone(values.phone)) && (
          <FormB.Control.Feedback type="invalid">
            {errors.phone || t('not_correct_phone', { ns: 'signup' })}
          </FormB.Control.Feedback>
          )}
          <InlinePass>
            <Field
              name="password"
              disabled={isSubmitting}
              required
              className="form-control-lg"
              placeholder={t('password_placeholder', { ns: 'signup' })}
              type={mainPass ? 'password' : 'text'}
              component={ArtField}
              column
              onFocus={() => setShow(!show)}
              onBlur={() => setShow(!show)}
              onChange={handlePasswordCheck}
              append={(
                <Eye
                  type="button"
                  onClick={() => setMainPass(!mainPass)}
                >
                  <Icon
                    icon="eye"
                    colorFill="#FFF"
                    width={24}
                    height={12}
                    colorStroke={mainPass ? MAIN_GRAY : ACTIVE}
                    noHover
                  />
                </Eye>
                )}
            />
            <Field
              name="passwordRepeat"
              disabled={isSubmitting}
              required
              className="form-control-lg"
              onFocus={() => setShowRepeat(!showRepeat)}
              onBlur={() => setShowRepeat(!showRepeat)}
              placeholder={t('confirm_password_placeholder', { ns: 'signup' })}
              type={repeatPass ? 'password' : 'text'}
              component={ArtField}
              append={(
                <Eye
                  type="button"
                  onClick={() => setRepeatPass(!repeatPass)}
                >
                  <Icon
                    icon="eye"
                    colorFill="#FFF"
                    width={24}
                    height={12}
                    colorStroke={repeatPass ? MAIN_GRAY : ACTIVE}
                    noHover
                  />
                </Eye>
                )}
              column
            />
          </InlinePass>
          <div>
            <Button
              variant="primary"
              type="submit"
              onClick={() => metrica('registration')}
              disabled={isSubmitting || !(dirty && isValid)}
            >
              {isSubmitting ? t('await', { ns: 'action' }) : t('registration', { ns: 'signup' })}
            </Button>
            <Authorization>
              <div>{t('have_account', { ns: 'signup' })}</div>
              <Button
                variant="link"
                disabled={isSubmitting}
                className="ms-2"
                onClick={() => setLogin(true)}
              >
                {t('authorization', { ns: 'signup' })}
              </Button>
            </Authorization>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const Authorization = styled.div`
  display: flex;
  grid-gap: 15px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  margin-top: 20px;
  color: ${ACTIVE};
  .btn-link {
    font-weight: 500;
    width: auto !important;
    margin-left: -10px !important;
    text-decoration: none;
    font-size: 16px;
    padding: 0;
    color: ${ACTIVE};
  }
  @media screen and (max-width: 600px) {
    font-size: 12px;
    .btn-link{
      font-size: 12px;
    }
  }
  @media screen and (max-width: 350px) {
    flex-direction: column;
  }
`;

const InlinePass = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

const LinkReset = styled(Link)`
  display: block;
  text-align: right;
  width: 100%;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  &:hover {
    color: rgba(0, 0, 0, 0.5);
    text-decoration: underline;
  }
`;

LoginRegister.propTypes = {
  path: PropTypes.string.isRequired,
  labelLogin: PropTypes.object.isRequired,
};

export default LoginRegister;
